"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var DownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M5.3 8.3a1 1 0 011.4 0l5.3 5.29 5.3-5.3a1 1 0 111.4 1.42l-6 6a1 1 0 01-1.4 0l-6-6a1 1 0 010-1.42z" } }] }, "name": "down", "theme": "outlined" };
exports.default = DownOutlined;
